import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateNotification($companyId: ID!, $id: ID!, $attributes: NotificationAttributes!) {
    updateNotification(companyId: $companyId, id: $id, attributes: $attributes) {
      notification {
        id
        ...UpdatedNotification
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedNotification on Notification {
    id
    title
    message
    postedAt
    readAt
  }
`
